import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'app-duplicate',
    templateUrl: './duplicate.component.svg',
    styleUrls: ['./duplicate.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DuplicateComponent {}
